class ArticleCards {
	constructor(sel) {
		// view
		this.cname = '.article-cards';
		this.components = document.querySelectorAll(this.cname);
		this.allContent = null;

		if (this.components) {
			this.init();
		}
	}

	init() {
		this.components.forEach( component => {
			if (!this.allContent) {
				let content = component.querySelector(".wrapper-articles");
				this.allContent = content.innerHTML;
			}
			this.setEvents(component);
		});
	}
	setEvents(component) {

		// ELEMENTS
		const filters = component.querySelectorAll(".article-cards__filters a");
		const search = component.querySelector(".article-cards__search input");
		const dropdownMobile = component.querySelector(".article-cards_dropdown");

		// EVENTS
		filters.forEach( filter => {
			filter?.addEventListener('click', e => {
				e.preventDefault();
				let target = e.target;
				if (target)  {
					this.filters(component, target)
					dropdownMobile.parentNode.classList.remove("active");
				}
			});
		});
		search?.addEventListener('input', e => {
			const query = e.target.value;

			clearTimeout(this.searchTimeout);

			this.searchTimeout = setTimeout(() => {
				this.search(component, query);
			}, 500);
		});
		document.body.addEventListener('click', e => {
			if (e.target.matches(".page-numbers.next")) {
				e.preventDefault();
				let target = e.target;
				if (target != "") this.filters(component, target);
			}
		});
		dropdownMobile?.addEventListener('click', e => {
			e.preventDefault();
			dropdownMobile.parentNode.classList.toggle("active");
		});

	}
	search(component, query) {
		let articles = component.querySelectorAll(".article-card");
		let allHidden = true;

		if (query.length > 2) {
			articles.forEach(card => {
				let h3 = card.querySelector("h3");
				if (h3 && h3.textContent.toLowerCase().includes(query.toLowerCase())) {
					card.classList.remove("hide");
					allHidden = false;
				} else {
					card.classList.add("hide");
				}
			});
			component.classList.add("filter-by-search");

			if (allHidden) {
				component.classList.add("show-no-result");
			} else {
				component.classList.remove("show-no-result");
			}
		} else {
			articles.forEach(card => card.classList.remove("hide"));
			component.classList.remove("filter-by-search");
			component.classList.remove("show-no-result");
		}
	}
	filters(component, target) {

		const container = component.querySelector(".wrapper-articles");
		let URLCATEGORY = target.href;

		console.log(URLCATEGORY, URLCATEGORY != "#");

		if (URLCATEGORY && URLCATEGORY != "#") {
			this.resetItems(component);
			target.classList.add("active");
	
			fetch(URLCATEGORY)
			.then((response) => response.text())
			.then((html) => {
				const articles = this.parseEventsHTML(html);
				container.innerHTML = articles;
			})
			.catch((error) => {
				console.error("Error fetching events:", error);
			})
			.finally(() => this.toggleLoader(component, false));
		} else {
			container.innerHTML = this.allContent;
		}

	}
	parseEventsHTML(html) {
		const parser = new DOMParser();
		const doc = parser.parseFromString(html, "text/html");
		const articles = doc.querySelector(".wrapper-articles");
		return articles ? articles.innerHTML : "";
	}
	toggleLoader(component, show) {
		component.classList.toggle("show-loader", show);
	}
	resetItems(component) {
		let items = component.querySelectorAll(".article-cards__filters a");
		if (items) items.forEach(item => item.classList.remove("active"));
	}
}

new ArticleCards();
